import { render } from "./underDev.vue?vue&type=template&id=dd7a67cc"
import script from "./underDev.vue?vue&type=script&lang=js"
export * from "./underDev.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\wld\\wlt-admin-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__